import {
  ColorDto,
  FontDto,
  LogoOptionsDto,
  TransferMethodDto,
} from "../responses/logoOptionsDto";
import {
  Color,
  Font,
  LogoOptions,
  TransferMethod,
} from "../../../core/models/entities/LogoOptions";

export function mapLogoOptions(dto: LogoOptionsDto): LogoOptions {
  // Null-guards on every catalog array: a partial/degraded payload must not
  // throw inside the query transform — that would flip the consuming screen
  // (design/logo editor panels) to the error view even though the server
  // responded 200.
  return {
    ...dto,
    transferMethods: dto.transferMethods
      ? dto.transferMethods.map(mapToTransferMethod)
      : [],
    transferMethodsNumbers: dto.transferMethodsNumbers
      ? dto.transferMethodsNumbers.map(mapToTransferMethod)
      : [],
    transferMethodsNames: dto.transferMethodsNames
      ? dto.transferMethodsNames.map(mapToTransferMethod)
      : [],
    colors: dto.colors ? dto.colors.map(mapToColor) : [],
    allColors: dto.allColors ? dto.allColors.map(mapToColor) : [],
    colorsEmbroidery: dto.colorsEmbroidery
      ? dto.colorsEmbroidery.map(mapToColor)
      : [],
    transferLogoTypes: dto.logoTypes ?? [],
    fonts: dto.fonts ? dto.fonts.map(mapToFont) : [],
    fontSizes: dto.fontSizes ? dto.fontSizes.map(mapToFontSize) : [],
    fontSizesNumbers: dto.fontSizesNumbers
      ? dto.fontSizesNumbers.map(mapToFontSize)
      : [],
    fontSizesNames: dto.fontSizesNames
      ? dto.fontSizesNames.map(mapToFontSize)
      : [],
    blockedMethodKeys: dto.blockedMethodKeys ?? [],
    // Fail-open: an API that doesn't send the flag yet behaves as "enabled".
    stockOrdersDisabled: dto.stockOrdersDisabled ?? false,
    // Per-user effective block; an API that doesn't send it yet (pre
    // per-customer-blocking deploy) falls back to the global flag.
    stockOrdersEffectiveDisabled:
      dto.stockOrdersEffectiveDisabled ?? dto.stockOrdersDisabled ?? false,
  };
}

function mapToColor(dto: ColorDto): Color {
  return dto;
}

function mapToTransferMethod(dto: TransferMethodDto): TransferMethod {
  return dto;
}

function mapToFont(dto: FontDto): Font {
  return dto;
}

function mapToFontSize(dto: number): number {
  return dto;
}
